import type { SxProps, Theme } from '@mui/material/styles'
import { homeContentShellSx } from '@/features/home/styles/homeStyles'

export {
  homeContentInnerSx as historyContentInnerSx,
  homePageRootSx as historyPageRootSx,
} from '@/features/home/styles/homeStyles'

export const historyContentShellSx = {
  ...homeContentShellSx,
  flex: 1,
  pb: 4,
} as const

export const historyTitleSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: { xs: '24px', md: '32px' },
  fontWeight: 700,
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: '#0f1729',
  mt: { xs: 3, md: '25px' },
  mb: '8px',
}

export const historySubtitleSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  color: '#6b7a90',
  mb: { xs: 3, md: '24px' },
}

export const historyCardListSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}

export const historyCardSx: SxProps<Theme> = {
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: { xs: '48px minmax(0, 1fr)', md: '60px 1fr auto' },
  alignItems: 'center',
  columnGap: { xs: '12px', md: '17px' },
  rowGap: { xs: '10px', md: 0 },
  height: { xs: 'auto', md: '94px' },
  minHeight: { xs: 88, md: 94 },
  boxSizing: 'border-box',
  bgcolor: '#ffffff',
  border: '1px solid #ddeaf2',
  borderRadius: '14px',
  boxShadow: '0px 1px 3px rgba(0, 140, 208, 0.06)',
  pl: { xs: '12px', md: '15px' },
  pr: { xs: '12px', md: '16px' },
  py: { xs: 1.5, md: 0 },
  pointerEvents: 'none',
  '& > :last-child': {
    gridColumn: { xs: '1 / -1', md: 'auto' },
    justifySelf: { xs: 'start', md: 'auto' },
  },
} as const

export const historyIconTileSx: SxProps<Theme> = {
  width: { xs: 48, md: 60 },
  height: { xs: 48, md: 60 },
  borderRadius: '6px',
  bgcolor: '#e6ecff',
  border: '1px solid #bdceff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}

export const historySurveyIconSx: SxProps<Theme> = {
  width: 32,
  height: 32,
  display: 'block',
  objectFit: 'contain',
}

export const historyCardBodySx: SxProps<Theme> = {
  minWidth: 0,
  alignSelf: { xs: 'center', md: 'start' },
  pt: { xs: 0, md: '22px' },
  pr: { xs: 0, md: 2 },
}

export const historyCardTitleSx: SxProps<Theme> = {
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  color: '#0d1b2a',
  mb: '4px',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
} as const

export const historyCardDateRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  color: '#8fa8b8',
  fontSize: '13px',
  lineHeight: '19.5px',
}

export const historyEarnPillSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  height: 31,
  px: '13px',
  py: '5px',
  borderRadius: '20px',
  bgcolor: '#e8f5ef',
  border: '1px solid #b6e8d5',
  flexShrink: 0,
}

export const historyEarnTextSx: SxProps<Theme> = {
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  color: '#0e8a5f',
  whiteSpace: 'nowrap',
}

export const historyNoRewardPillSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  height: 31,
  px: '13px',
  py: '5px',
  borderRadius: '20px',
  bgcolor: '#e2e8f0',
  border: '1px solid #e2e8f0',
  flexShrink: 0,
}

export const historyNoRewardTextSx: SxProps<Theme> = {
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '18px',
  color: '#94a3b8',
  whiteSpace: 'nowrap',
}

export const historyLoadMoreWrapSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  mt: 4,
}

export const historyLoadMoreButtonSx: SxProps<Theme> = {
  minWidth: 112,
  height: 42,
  borderRadius: '9px',
  border: '1px solid #94a3b8',
  color: '#64748b',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  textTransform: 'none',
  '&:hover': {
    border: '1px solid #94a3b8',
    bgcolor: 'rgba(148, 163, 184, 0.08)',
  },
}

export const historyEmptyWrapSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  pt: 2,
  pb: 6,
}

export const historyEmptyMessageSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  color: '#0f1729',
  maxWidth: 520,
  mt: '23px',
}
